import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete, Typography, Box, Grid } from '@mui/material';
import BaseModal from './BaseModal';
import rootAxios from '../../../requests/rootAxios';

const ClusterWiseModal = ({
  open,
  onClose,
  onSubmit,
  loading,
  reportType,
  availableRegions,
  availableBranches,
  trainingTypes,
  dispatch,
}) => {
  const [filters, setFilters] = useState({
    cluster: null,
    dateRange: {
      startDate: null,
      endDate: null,
    },
    trainingType: null,
  });
  const [clusters, setClusters] = useState([]);
  // Mock clusters data - in real app, this would come from API
  // get list of cluser via
  // user/get-all-clusters
  const getClusters = async () => {
    const response = await rootAxios.get('/user/get-all-clusters');
    console.log('clusters', response.data.data);
    setClusters(response.data.data);
  };

  useEffect(() => {
    getClusters();
  }, []);

  const handleClusterChange = (event, value) => {
    setFilters((prev) => ({ ...prev, cluster: value }));
  };

  const handleTrainingTypeChange = (event, value) => {
    setFilters((prev) => ({ ...prev, trainingType: value }));
  };

  const handleDateChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        [field]: value,
      },
    }));
  };

  const handleSubmit = () => {
    const payload = {
      cluster: filters.cluster?.CLUSTER_MANAGER_ID,
      trainingTypeName: filters.trainingType?.trainingName,
      startDate: filters.dateRange.startDate,
      endDate: filters.dateRange.endDate,
    };

    console.log('ClusterWiseModal payload:', payload);
    onSubmit(payload);
  };

  const handleClose = () => {
    setFilters({
      cluster: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      trainingType: null,
    });
    onClose();
  };

  const isSubmitDisabled =
    !filters.cluster ||
    !filters.dateRange.startDate ||
    !filters.dateRange.endDate ||
    !filters.trainingType;

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      loading={loading}
      reportType={reportType}
      submitDisabled={isSubmitDisabled}
    >
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, color: 'text.primary', fontWeight: 600 }}>
          Select Filters
        </Typography>

        <Grid container spacing={3}>
          {/* Cluster */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Cluster *
            </Typography>
            <Autocomplete
              options={clusters}
              getOptionLabel={(option) => `${option.CLUSTER_NAME} - ${option.CLUSTER_MANAGER_ID}`}
              value={filters.cluster}
              onChange={handleClusterChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select cluster"
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1.5,
                    },
                  }}
                />
              )}
            />
          </Grid>

          {/* Training Type */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Training Type *
            </Typography>
            <Autocomplete
              options={trainingTypes || []}
              getOptionLabel={(option) => option.trainingName || ''}
              value={filters.trainingType}
              onChange={handleTrainingTypeChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select training type"
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1.5,
                    },
                  }}
                />
              )}
            />
          </Grid>

          {/* Date Range */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Start Date *
            </Typography>
            <TextField
              type="date"
              fullWidth
              size="small"
              value={filters.dateRange.startDate || ''}
              onChange={(e) => handleDateChange('startDate', e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              End Date *
            </Typography>
            <TextField
              type="date"
              fullWidth
              size="small"
              value={filters.dateRange.endDate || ''}
              onChange={(e) => handleDateChange('endDate', e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </BaseModal>
  );
};

export default ClusterWiseModal;
